import { generatePermissionForEntity } from '../util';
export var StorePermissions;
(function (StorePermissions) {
    StorePermissions["WEB_READ_HOME_PAGE"] = "WEB_READ_HOME_PAGE";
    StorePermissions["TEAMS_PAGE_VIEW"] = "TEAMS_PAGE_VIEW";
    StorePermissions["NAVBAR_VIEW"] = "NAVBAR_VIEW";
    StorePermissions["HOME_PAGE_VIEW"] = "HOME_PAGE_VIEW";
    StorePermissions["GENERAL_SETTINGS_PAGE_VIEW"] = "GENERAL_SETTINGS_PAGE_VIEW";
    StorePermissions["POS_SETTINGS_PAGE_VIEW"] = "POS_SETTINGS_PAGE_VIEW";
    StorePermissions["PRINT_TAGS_PAGE_VIEW"] = "PRINT_TAGS_PAGE_VIEW";
    StorePermissions["PREPARATION_TIME_PAGE_VIEW"] = "PREPARATION_TIME_PAGE_VIEW";
    StorePermissions["DELIVER_PAGE_VIEW"] = "DELIVER_PAGE_VIEW";
    StorePermissions["PICKUP_PAGE_VIEW"] = "PICKUP_PAGE_VIEW";
    StorePermissions["BUSINESS_HOURS_PAGE_VIEW"] = "BUSINESS_HOURS_PAGE_VIEW";
    StorePermissions["STYLING_PAGE_VIEW"] = "STYLING_PAGE_VIEW";
    StorePermissions["INTEGRATIONS_PAGE_VIEW"] = "INTEGRATIONS_PAGE_VIEW";
    StorePermissions["CONFIGURATIONS_PAGE_VIEW"] = "CONFIGURATIONS_PAGE_VIEW";
})(StorePermissions || (StorePermissions = {}));
export const STORE_PERMISSIONS = generatePermissionForEntity('STORE', StorePermissions);
//# sourceMappingURL=store.js.map